import React from "react";
import CustomSelect from "../common/Select";

const opcionesSexo = [
  { value: "01", label: "HOMBRE" },
  { value: "02", label: "MUJER" }
];

function SelectorSexo({ value, onChange, error, required = false }) {
  return (
    <CustomSelect
      options={opcionesSexo}
      value={value}
      onChange={onChange}
      placeholder="Sexo"
      label="Sexo"
      error={error}
      required={required}
    />
  );
}

export default SelectorSexo;